import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  base64: null,
  url: null,
  fileName: null,
  signatures: [],
  fields: [],
  error: null,
  numPages: null,
};

const pdfSlice = createSlice({
  name: "pdf",
  initialState,
  reducers: {
    setPdfFile: (state, action) => {
      const { base64, url, fileName } = action.payload;
      state.base64 = base64;
      state.url = url;
      state.fileName = fileName;
      state.signatures = [];
      state.fields = [];
      state.error = null;
      state.numPages = null;
    },
    clearPdf: (state) => {
      if (state.url) URL.revokeObjectURL(state.url);
      return { ...initialState };
    },
  },
});

export const { setPdfFile, clearPdf } = pdfSlice.actions;

export default pdfSlice.reducer;
